module.exports = __webpack_public_path__ + "img/skull_6.b7a012f2.png";